import {
    RaikoButtonPrimary,
    RaikoGridOneColumn,
    showErrorMessage, showSuccessMessage, showWarningMessage, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {readToken} from "../../../../service/authService/AuthService";
import axios from "axios";
import "./AccountMonthlyDepositReceipt.scss"
import {AccountService} from "../../../../serverService/account/AccountService";
import {useAuthState} from "../../../../context/AuthContext";
import {detectServerErrorMessage} from "../../../../util/detectServerErrorMessage";
import {Skeleton} from "@mui/material";

export default function AccountMonthlyDepositReceipt(
    {
        transactionId,
        receiptUrl,
        handleUpdateReceipt
    }
) {
    const {fundID} = useAuthState()

    const [imageFile, setImageFile] = useState(null)
    const [image, setImage] = useState("");
    const [thumbnailLoading, setThumbnailLoading] = useState(false);

    const [loadingReceipt, setLoadingReceipt] = useState(false);

    const service = new AccountService()

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const token = readToken();

                const response = await axios.get(receiptUrl, {
                    headers: {
                        Authorization: `bearer ${token}`,
                        'realm-name': 'raiko-manager-fund-web'
                    },
                    responseType: 'blob'
                });

                const imageObjectURL = URL.createObjectURL(response.data);
                setImage(imageObjectURL);
                setLoadingReceipt(false)
            } catch (error) {
                showErrorMessage('خطا در دریافت رسید تراکنش');
                setLoadingReceipt(false)
            }
        };

        if (receiptUrl && receiptUrl.length > 0) {
            setLoadingReceipt(true)
            fetchImage();
        }
    }, [receiptUrl]);


    function handleUpdateThumbnail() {
        if (imageFile) {
            setThumbnailLoading(true)
            service.uploadReceiptFile(
                fundID,
                transactionId,
                imageFile
            ).then(response => {
                showSuccessMessage("بروزرسانی رسید با موفقیت انجام شد.")
                if (handleUpdateReceipt)
                    handleUpdateReceipt(response, transactionId)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setThumbnailLoading(false)
            })
        } else
            showWarningMessage("لطفا ابتدا تصویر رسید مورد نظر را انتخاب نمایید.")
    }

    function uploadReceiptImageFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setImageFile(files[0])
            // setImageName(files[0].name)
            setImage(URL.createObjectURL(files[0]))
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>

            <div
                className={"baseReceiptCardContainer"}
                onClick={_ => document.getElementById("receiptImageFile").click()}
            >
                <input
                    type="file"
                    id="receiptImageFile"
                    hidden={true}
                    multiple={true}
                    accept="image/png,image/gif,image/jpeg"
                    onChange={uploadReceiptImageFile}
                />
                {
                    loadingReceipt ?
                        <Skeleton variant="rectangular" className={css`padding: 100px 200px`}/> :
                        image ?
                            <img
                                src={image}
                                id={"image"}
                                alt="receiptImageFile"/> :
                            imageFile ?
                                <img
                                    src={imageFile}
                                    id={"image"}
                                    alt="receiptImageFile"/>
                                :
                                <div className="ic-picture"/>
                }
                <span>برای انتخاب رسید وام کلیک نمایید.</span>
                <div
                    onDragOver={event => {
                        event.stopPropagation();
                        event.preventDefault();
                        event.dataTransfer.dropEffect = 'copy';
                    }}
                    onDrop={event => {
                        event.stopPropagation();
                        event.preventDefault();
                        uploadReceiptImageFile({target: {files: event.dataTransfer.files}})
                    }}
                    id="uploadImageContent">

                </div>
            </div>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"بروزرسانی"}
                    onClick={handleUpdateThumbnail}
                    loading={thumbnailLoading}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
